import React, { useCallback, useEffect, useState } from "react";
import api from "../../api/axios";

import ScenarioToolbar from "./ScenarioToolbar";
import { useParams } from "react-router-dom";
import SectionManager from "../DataConfiguration/Section/SectionManager";
import ScenarioSettingsPanel from "../DataConfiguration/PanelSettings/ScenarioSettingsPanel";
import "./ScenarioManager.css";

const ScenarioManager = () => {
  const { scenarioId } = useParams();
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [activeTab, setActiveTab] = useState("section");

  useEffect(() => {
    if (!scenarioId) return;

    api.get(`/scenario/${scenarioId}`)
      .then((res) => setSelectedScenario(res.data))
      .catch((err) => {
        console.error("Failed to load scenario:", err);
      });
  }, [scenarioId]);

  // Called after every (auto)save of the toolbar, sections or settings.
  // Merges into the latest state instead of replacing it, so two saves that
  // finish close together don't undo each other in the UI.
  const handleScenarioUpdated = useCallback((updated) => {
    setSelectedScenario((prev) => (prev && updated ? { ...prev, ...updated } : updated));
    window.dispatchEvent(new Event("scenario-updated"));
  }, []);

  const handleToggleDefault = async (checked) => {
    if (!selectedScenario) return;
    try {
      if (checked) await api.post(`/scenario/${selectedScenario.id}/default`);
      else await api.delete(`/scenario/${selectedScenario.id}/default`);

      setSelectedScenario((prev) => ({ ...prev, isDefault: checked }));
      window.dispatchEvent(new Event("scenario-updated"));
    } catch (err) {
      console.error("Failed to change default scenario:", err);
      alert("Default scenario could not be changed.");
    }
  };

  return (
    <div className="scenario-manager-container">
      <ScenarioToolbar
        selectedScenario={selectedScenario}
        onScenarioUpdated={handleScenarioUpdated}
      />

      {selectedScenario && (
        <div className="scenario-details-container">
          <div className="data-config-container">
            <label className="scenario-default-toggle">
              <input
                type="checkbox"
                checked={!!selectedScenario.isDefault}
                onChange={(e) => handleToggleDefault(e.target.checked)}
              />
              Use as default scenario
            </label>

            <div className="tab-button-row">
              <button
                className={`tab-btn ${activeTab === "section" ? "active" : ""}`}
                onClick={() => setActiveTab("section")}
              >
                Section
              </button>

              <button
                className={`tab-btn ${activeTab === "settings" ? "active" : ""}`}
                onClick={() => setActiveTab("settings")}
              >
                Panel Settings
              </button>
            </div>

            {activeTab === "section" && (
              <SectionManager
                scenario={selectedScenario}
                onScenarioUpdated={handleScenarioUpdated}
              />
            )}

            {activeTab === "settings" && (
              <ScenarioSettingsPanel
                scenario={selectedScenario}
                onScenarioUpdated={handleScenarioUpdated}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScenarioManager;
